import React, { ComponentProps, useEffect, useState } from 'react';
import { completeTarget } from 'config/api';
import { useCustomHederSideMenu } from 'hooks/useCustomHederSideMenu';
import { useCustomHeaderTitle } from 'hooks/useCustomHeaderTitle';
import { useModal } from 'hooks/useModal';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { useTargetAchievementSupportContext } from 'contexts/TargetAchievementSupportContext';
import { formatDate } from 'utils/formatter';
import { useTargetSupportRouting } from 'components/features/target-achievement-support/hooks/useTargetSupportRouting';
import { Target } from 'components/features/target-achievement-support/utils/type';
import { targetTypeToTitle } from 'components/features/target-achievement-support/utils/targetInfo';
import { PeriodTabs } from './components/PeriodTabs';
import { SetHowToSavePopUp } from './components/SetHowToSavePopUp';
import { TargetInformationBasic } from './components/TargetInformationBasic';
import { EndTargetModal } from '../modal/EndTargetModal';

export const TargetOnly = ({
  target,
  birthday,
}: {
  target: Target;
  birthday: Date;
}) => {
  useCustomHederSideMenu();
  useCustomHeaderTitle('資産目標サポート');
  const {
    updateGlobalTarget,
    updateConfirmGlobalTarget,
    updateIsFirstFlg,
  } = useTargetAchievementSupportContext();

  const {
    goTargetIndex,
    goSetTitle,
    goTargetPushUpdateStep1,
  } = useTargetSupportRouting();

  const { setBack } = useCustomizeHeaderContext();
  useEffect(() => {
    setBack({ backFunction: () => goTargetIndex() });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [period, setPeriod] = useState<
    ComponentProps<typeof PeriodTabs>['period']
  >('Month');
  const [endTargetId, setEndTargetId] = useState<string | null>(null);

  const [isShow, { hideModal, showModal }] = useModal();

  const goRegisterHowToSave = () => {
    updateIsFirstFlg(true);
    updateGlobalTarget(null);
    updateConfirmGlobalTarget(null);
    goTargetPushUpdateStep1(target.id, 'new');
  };

  const endTarget = async (): Promise<void> => {
    if (endTargetId === null) return;
    await completeTargetAPI(endTargetId);
    goTargetIndex();
  };

  const showEndTargetModal = (id: string) => {
    setEndTargetId(id);
    showModal();
  };

  // Google tag manager
  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('chrome') !== -1) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'target_detail',
        targetinfo: `${target.id}_${target.title}_${targetTypeToTitle(
          target.refType
        )}_${formatDate(new Date(), 'yyyyMMddHHmmss')}`,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <TargetInformationBasic
        target={target}
        birthday={birthday}
        isShowRemainDate
        updateTarget={(): void => goTargetPushUpdateStep1(target.id, 'new')}
        editTitle={(): void => goSetTitle(target.id)}
        endTarget={(): void => showEndTargetModal(target.id)}
      />
      <div className="px-4">
        <PeriodTabs {...{ period, setPeriod, canSelect: false }} />
      </div>
      <div className="relative z-0 bg-white pt-8 px-3">
        <img
          src="/static/images/advisor/dummy-chart.svg"
          alt="ダミーチャート"
          className="shadow"
        />
        <SetHowToSavePopUp
          {...{
            setHowToSave: () => goRegisterHowToSave(),
          }}
        />
      </div>
      <EndTargetModal
        {...{
          endTarget,
          hide: hideModal,
          isShow,
        }}
      />
    </>
  );
};

const completeTargetAPI = async (id: string): Promise<void> => {
  await completeTarget(id);
};
